import {IconButton, Box, useTheme} from '@mui/material';
import {LinkedIn, YouTube} from '@mui/icons-material';
import {Stack} from '@mui/material';
import takedaLogo from 'assets/images/header/takedaLogo.svg';

export const FooterSocial = () => {
  const theme = useTheme();
  return (
    <>
      <Stack direction='row' justifyContent='flex-start' alignItems='center' spacing={1} width='100%'>
        <Box flexGrow={1}>
          <IconButton
            href='https://www.takeda.com/'
            target='_blank'
            size='medium'
            sx={{
              '&:hover': {
                backgroundColor: 'white',
                color: 'inherit',
              },
              background: 'white',
            }}
          >
            <img width={90} src={takedaLogo} alt='Takeda Logo' />
          </IconButton>
        </Box>
        <IconButton
          href='https://www.linkedin.com/company/takeda-pharmaceuticals/'
          target='_blank'
          size='medium'
          sx={{
            '&:hover': {
              backgroundColor: theme.palette.grey[800],
              color: 'inherit',
            },
            background: theme.palette.grey[800],
          }}
        >
          <LinkedIn fontSize='medium' sx={{borderRadius: 50, color: 'white', background: [theme.palette.grey[800]]}} />
        </IconButton>
        <IconButton
          href='https://www.youtube.com/takeda-pharmaceuticals'
          target='_blank'
          size='medium'
          sx={{
            '&:hover': {
              backgroundColor: theme.palette.grey[800],
              color: 'inherit',
            },
            background: theme.palette.grey[800],
          }}
        >
          <YouTube fontSize='medium' sx={{borderRadius: 50, color: 'white', background: [theme.palette.grey[800]]}} />
        </IconButton>
      </Stack>
    </>
  );
};
